import angular from 'angular';
import { BRAND_NAME } from '../../../core/main/controller/environment';

import '../../../core/main/filter/country_date_format/filter';
import '../../../core/main/filter/order_channel/filter';
import '../../../core/main/filter/brand_name/filter';
import '../../../core/main/factory/analytics';
import '../../../main/factory/order_transaction';
import '../../../main/factory/authentication';
import '../../../core/main/directive/numbers_only/directive'
import '../../../core/main/directive/order/directive'
import '../../../core/main/directive/paginate/directive'
import '../../../core/main/directive/query/directive'
import './style.scss';
import i18next from "i18next";

document.write(require('./view.html').default);

angular.module("merchant.application.module.order.list", ['jm.i18next',
    "merchant.application.module.order.refund",
    "ngQuickDate",
]).controller("merchant.application.module.order.list.controller", [
    "$rootScope", "$scope", "$controller", "$window",
    "merchant.application.main.factory.orderTransaction",
    "merchant.application.main.factory.authentication",
    "core.application.main.factory.feature",
    "core.application.main.factory.analytics",
    function($rootScope, $scope, $controller, $window, OrderTransaction, Authentication, Feature, Analytics) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.orderList) {
            $scope.model.orderList = {};
        }
        $scope.model.orderList.data = {};
        $scope.model.orderList.populating = false;

        $scope.model.orderList.search = {
            queryParameters: {
                limit: "20",
                orderBy: "ORDER_DATE",
                ascending: "false"
            }
        };
        $scope.model.orderList.search.parameters = angular.copy($scope.model.orderList.search.queryParameters);
        $scope.model.orderList.originalSearchSettings = angular.copy($scope.model.orderList.search);

        function loadStatusDropdown() {
            $scope.model.orderList.statuses = [
                {
                    id: "APPROVED",
                    name: i18next.t("general:status-approved")
                },
                {
                    id: "DECLINED",
                    name: i18next.t("general:status-declined")
                }
            ];


            $scope.model.orderList.statusPrimaryFieldEnabled = false;
            Feature.retrieveFeatureFlagPromise("merchant-portal-status-search-enabled", false)
                .then(function (value) {
                    $scope.model.orderList.statusPrimaryFieldEnabled = value;
                    // need to apply to update the view in case
                    // feature flag is set after view is loaded
                    $scope.$apply();
                });
        }



        function loadChanelDropdown() {
            $scope.model.orderList.orderChannels = [
                {
                    id: "ONLINE",
                    name: i18next.t("general:online")
                },
                {
                    id: "IN_STORE",
                    name: i18next.t("general:instore")
                },
                {
                    id: "IN_STORE_CARD",
                    name: `${BRAND_NAME} ${i18next.t("general:card-instore")}`
                }
            ];


            $scope.model.ecommerceChannelAdminPortalFeatureFlag = false;
            Feature.retrieveFeatureFlagPromise("ecommerce-channel-admin-portal", false)
                .then(function (value) {
                    $scope.model.ecommerceChannelAdminPortalFeatureFlag = value;

                    if ($scope.model.ecommerceChannelAdminPortalFeatureFlag) {
                        $scope.model.orderList.orderChannels.splice(3, 0, {
                            id: "IN_STORE_CARD_ONLINE",
                            name: `${BRAND_NAME} ${i18next.t("general:card-ecommerce")}`
                        })
                        // need to apply to update the view in case
                        // feature flag is set after view is loaded
                        $scope.$apply();
                    }
                });

            $scope.model.moneyChannelDisplayFeatureFlag = false;
            Feature.retrieveFeatureFlagPromise("money-channel-admin-portal-enabled", false)
                .then(function (value) {
                    $scope.model.moneyChannelDisplayFeatureFlag = value;

                    if ($scope.model.moneyChannelDisplayFeatureFlag) {
                        $scope.model.orderList.orderChannels.splice(4, 0, {
                            id: "MONEY",
                            name: i18next.t("general:money")
                        })
                        // need to apply to update the view in case
                        // feature flag is set after view is loaded
                        $scope.$apply();
                    }
                });

            $scope.model.cashAppChannelDisplayFeatureFlag = false;
            Feature.retrieveFeatureFlagPromise("cash-app-channel-enabled", false)
                .then(function (value) {
                    $scope.model.cashAppChannelDisplayFeatureFlag = value;

                    if ($scope.model.cashAppChannelDisplayFeatureFlag) {
                        $scope.model.orderList.orderChannels.splice(5, 0, {
                            id: "CASH_APP",
                            name: i18next.t("general:cash-app-pay")
                        })
                        // need to apply to update the view in case
                        // feature flag is set after view is loaded
                        $scope.$apply();
                    }
                });
        }

        loadChanelDropdown();
        loadStatusDropdown();

        i18next.on("loaded", () => {
            loadChanelDropdown();
            loadStatusDropdown();
        })

        $scope.populate = function() {
            var parameters;
            if (!$scope.model.orderList.populating) {
                $scope.model.orderList.populating = true;
                parameters = $scope.model.orderList.search.queryParameters;
                parameters.merchantId = Authentication.merchantId();

                OrderTransaction.populateOrders(parameters, function(data) {
                    $scope.model.orderList.data = data;
                    $scope.model.orderList.search.pageLinks = {
                        next: data.next,
                        previous: data.previous
                    };
                    $scope.model.orderList.populating = false;
                }, function() {
                    $scope.model.orderList.populating = false;
                });
            }
        };

        $scope.search = function() {
            var parameters;
            var shouldSearch;
            if ($scope.isAnyPrimaryFilterSet()) {
                parameters = angular.copy($scope.model.orderList.search.parameters);
                shouldSearch = parseInt(parameters.shouldSearch, 10);
                if (shouldSearch) {
                    if (parameters.startDate) {
                        parameters.startDate.setHours(0, 0, 0, 0);
                        parameters.startDate = parameters.startDate.getTime();
                    }
                    if (parameters.endDate) {
                        parameters.endDate.setHours(23, 59, 59, 999);
                        parameters.endDate = parameters.endDate.getTime();
                    }
                    if (! $scope.isSecondaryFilterSearchAllowed()) {
                        // Clear these filters out if the secondary filter searching isn't allowed
                        // This can happen if you perform a search that used one of these secondary filters
                        // and then manually clear out the primary filter fields and search again
                        parameters.status = undefined;
                    }
                    angular.forEach(parameters, function(value, key) {
                        // PAYL-4838 the backend considers an empty string to be a valid
                        // search, but we don't want it to operate that way
                        // so clear the parameter out if it's an empty string
                        if (value === "") {
                            parameters[key] = undefined;
                        }
                    });
                    $scope.model.orderList.search.queryParameters = parameters;
                    $scope.populate();
                }
            } else {
                // This is needed in the following scenario:
                // 1. Perform a search
                // 2. Clear the results
                // 3. Press the browser back button to see your initial search results
                // 4. Press the browser forward button. You should see a cleared page
                // Without this code here, the results don't clear when you press the forward button
                $scope.clearSearch();
            }
        };

        $scope.newSearch = function() {
            $scope.model.orderList.search.parameters.shouldSearch = 1;
            // clear out the paginate state before searching
            $scope.model.orderList.search.parameters.rel = undefined;
            $scope.model.orderList.search.parameters.markedOrderId = undefined;
            $scope.model.orderList.search.parameters.markedOrderDate = undefined;
            $scope.model.orderList.search.parameters.markedOrderToken = undefined;
            $scope.search();
        };

        $scope.clearSearch = function() {
            $scope.model.orderList.search = angular.copy($scope.model.orderList.originalSearchSettings);
            $scope.model.orderList.search.parameters.shouldSearch = 0;
            $scope.model.orderList.search.queryParameters.shouldSearch = 0;
            $scope.form.$setPristine();
            $scope.model.orderList.data = {};
        };

        $scope.isAnyPrimaryFilterSet = function() {
            return !!(
                (
                    $scope.model.orderList.search &&
                    $scope.model.orderList.search.parameters
                ) &&
                (
                    $scope.model.orderList.search.parameters.orderId ||
                    $scope.model.orderList.search.parameters.merchantOrderId ||
                    $scope.model.orderList.search.parameters.consumerName ||
                    $scope.model.orderList.search.parameters.startDate ||
                    $scope.model.orderList.search.parameters.endDate ||
                    $scope.model.orderList.search.parameters.status
                )
            );
        };

        $scope.confirmStartDateLessThanEndDate = function() {
            // make sure the 'to' date is greater than the 'from' date
            var parameters = $scope.model.orderList.search.parameters;
            if (parameters.startDate > parameters.endDate) {
                parameters.endDate = undefined;
            }
            // render 'to' date, otherwise the invalid dates in the
            // calendar popup won't be disabled properly
            $scope.form.endDate.$render();
        };

        $scope.populateOrder = function(order, callback) {
            OrderTransaction.populate({
                orderId: order.id,
                merchantId: Authentication.merchantId()
            }, function(data) {
                callback(data);
            });
        };

        $scope.sendAmplitudeEvent = Analytics.sendAmplitudeEvent

        $scope.showRefundOrder = function(order) {
            if($scope.canRefundOrder(order)) {
                $scope.sendAmplitudeEvent('Clicked Refund button', {
                    merchantId: Authentication.merchantId(),
                    orderId: order.id
                })
                $scope.populateOrder(order, function(data) {
                    $scope.model.orderRefund = angular.copy(data);
                    $scope.model.orderSummary = angular.copy(data);
                    $scope.model.modulesIncludedInModal = ["order-refund.html"];
                    $scope.model.isModalVisible = true;
                });
            }
        };

        $scope.canRefundOrder = function(order) {
            const excludedSources = [
                "POS_CARD",
                "POS_CARD_ONLINE",
                "VIRTUAL_CARD_ONLINE",
                "SINGLE_USE_CARD",
                "POS",
                "ANYWHERE_CARD",
                "ANYWHERE_CARD_ONLINE",
                "CASH_APP_AP_BUTTON",
                "CASH_APP_VIRTUAL_CARD",
                "CASH_APP_SINGLE_USE_CARD",
                "TERMINAL"
            ];

            return (
                order &&
                !excludedSources.includes(order.source) &&
                order.status === "APPROVED" &&
                order.openToRefundAmount &&
                parseFloat(order.openToRefundAmount.amount) > 0
            );
        };

        $scope.hasRefund = function(refundStatus) {
            return refundStatus === "FULLY_REFUNDED" || refundStatus === "PARTIALLY_REFUNDED";
        };

        $scope.startDateFilter = function(date) {
            // PAYL-1865 Future dates aren't allowed
            return date <= new Date();

        };

        $scope.endDateFilter = function(date) {
            // PAYL-6267 A user search sets the end date time to almost midnight
            // to retrieve all of the orders for the day
            var filterDate = new Date();
            // AME-1394 enable set of future date to cater for XBT orders
            filterDate.setDate(filterDate.getDate() + 1);
            filterDate.setHours(23, 59, 59, 999);
            if (date > filterDate) {
                // PAYL-1865 Future dates aren't allowed
                return false;
            }
            if (! date) {
                // PAYL-1717 null dates should return true as well so that the date can be cleared
                return true;
            }
            if (! $scope.model.orderList.search.parameters.startDate) {
                // PAYL-1864 If the 'from' date isn't set then we still allow the 'to' date to be changed
                return true;
            }
            return date >= $scope.model.orderList.search.parameters.startDate;
        };

        $scope.fixInvalidDates = function() {
            // ngQuickDate can return null which converts to Invalid Date
            // so we manually convert it back to null again
            if (isNaN($scope.model.orderList.search.parameters.startDate)) {
                $scope.model.orderList.search.parameters.startDate = undefined;
            }
            if (isNaN($scope.model.orderList.search.parameters.endDate)) {
                $scope.model.orderList.search.parameters.endDate = undefined;
            }
        };

        $scope.isSecondaryFilterSearchAllowed = function() {
            // Some of the search filters retrieve too many orders from the database
            // So the orders take a long time to retrieve. This isn't a nice user experience.
            // For the filters that cause this we need to ensure at least one of the following filters
            // has been given a value as well, so that the database query doesn't need to search as many records
            return !!(
                $scope.model.orderList.statusPrimaryFieldEnabled ||
                $scope.model.orderList.search.parameters.orderId ||
                $scope.model.orderList.search.parameters.merchantOrderId ||
                $scope.model.orderList.search.parameters.consumerName ||
                $scope.model.orderList.search.parameters.orderChannels
            );
        };

        $scope.canVoidAuth = function(order) {
            return order && order.source !== "POS_CARD" && order.source !== "POS_CARD_ONLINE";
        };

        $scope.replaceOrder = function(updatedOrderData) {
            var orderIndex = 0;
            while ($scope.model.orderList.data.orders[orderIndex].id !== updatedOrderData.id &&
            orderIndex < $scope.model.orderList.data.orders.length) {
                ++orderIndex;
            }
            if (orderIndex <= $scope.model.orderList.data.orders.length) {
                $scope.updateSingleOrder($scope.model.orderList.data.orders[orderIndex], updatedOrderData);
            }
        }

        $scope.updateSingleOrder = function(oldOrder, updatedOrder) {
            // AME-709/AME-804: This is needed because the "updatedOrder" corresponds to a single-order response, while
            // the "oldOrder" is a single search result, which has a different mapping. Choosing to only change the
            // items that are most likely to change after a refund or void action on an order.
            oldOrder.amountAfterRefunds = updatedOrder.totalAfterRefund;
            oldOrder.amount = updatedOrder.merchantAmount;
            oldOrder.openToRefundAmount = updatedOrder.openToRefundAmount;
            oldOrder.status = updatedOrder.status;
            oldOrder.refundStatus = updatedOrder.refundStatus;
            oldOrder.settlementStatus = updatedOrder.settlementStatus;
        }

        $scope.voidAuth = function(order) {
            if ($scope.canVoidAuth(order) && $window.confirm("Are you sure?")) {
                OrderTransaction.void({
                    merchantId: Authentication.merchantId(),
                    transactionId: order && order.id
                }, function(updatedOrderData) {
                    $scope.replaceOrder(updatedOrderData);
                }, angular.noop); // No errors to display
            }
        };

        $rootScope.$on("orderableSortChanged", function(event, newSortingParameters) {
            $scope.model.orderList.search.parameters.orderBy = newSortingParameters.orderBy;
            $scope.model.orderList.search.parameters.ascending = newSortingParameters.ascending;
            $scope.newSearch();
        });

        $scope.$on("paginate:goToPage", function(event, pageParameters) {
            var parameters = angular.copy(pageParameters);
            parameters.shouldSearch = 1;
            if (parameters.startDate) {
                parameters.startDate = new Date(parseInt(parameters.startDate, 10));
            }
            if (parameters.endDate) {
                parameters.endDate = new Date(parseInt(parameters.endDate, 10));
            }
            $scope.model.orderList.search.parameters = parameters;
            $scope.search();
        });

        $scope.$on("refundedOrder", function(event, refundedOrder) {
            $scope.replaceOrder(refundedOrder);
        });

        $scope.$watch("model.orderList.search.queryParameters", function(queryParameters) {
            // keep the actual search parameters up to date based on the browser query parameters
            var parameters = angular.copy(queryParameters);
            if (parameters.startDate) {
                parameters.startDate = new Date(parseInt(parameters.startDate, 10));
            }
            if (parameters.endDate) {
                parameters.endDate = new Date(parseInt(parameters.endDate, 10));
            }
            $scope.model.orderList.search.parameters = parameters;
            $scope.search();
        }, true);

        $scope.sendSearchEvent = function(){
            if ($scope.isAnyPrimaryFilterSet()) {
                $scope.sendAmplitudeEvent('Clicked search button to search orders', $scope.model.orderList.search.parameters)
            }
        }


    }
]);
